import Cookies from 'js-cookie';
import { type StateStorage } from 'zustand/middleware';

const defaultAttr: Partial<Cookies.CookieAttributes> = {
  httpOnly: false,
  path: '/',
  sameSite: 'strict',
  secure: true,
};

const getExpiry = () => {
  // 400 days is the maximum Chrome will allow you to
  // set a cookie expiry/max-age.
  const expiresInMs = 400 * 24 * 60 * 60 * 1000;
  return new Date(Date.now() + expiresInMs);
};

export const createCookieStorage = (attr: Cookies.CookieAttributes = {}): StateStorage => ({
  getItem: (name: string): Promise<string | null> => {
    const result = Cookies.get(name);

    if (!result) {
      // StateStorage type requires promise is returned
      // eslint-disable-next-line unicorn/no-null
      return Promise.resolve(null);
    }

    return Promise.resolve(result);
  },
  // StateStorage type requires promise is returned
  // eslint-disable-next-line @typescript-eslint/require-await
  removeItem: async (name: string): Promise<void> => {
    Cookies.remove(name);
  },
  // StateStorage type requires promise is returned
  // eslint-disable-next-line @typescript-eslint/require-await
  setItem: async (name: string, value: string): Promise<void> => {
    Cookies.set(name, value, { ...defaultAttr, expires: getExpiry(), ...attr });
  },
});
